import { API_BASE_URL } from '../config/env';

const PAGE_SIZE = 50;

/** Misma búsqueda que Conversaciones.jsx — perfil por teléfono WhatsApp. */
export async function fetchAsociacionByPhone(phone, name = '') {
  const params = new URLSearchParams({
    phone: String(phone || ''),
    name: String(name || '')
  });
  const base = API_BASE_URL || '';
  const res = await fetch(`${base}/api/asociacion/by-phone?${params}`, {
    credentials: 'include'
  });
  if (!res.ok) return null;
  const json = await res.json().catch(() => ({}));
  return json?.data || null;
}

export async function fetchClientes(search = '') {
  const params = new URLSearchParams({
    page: '1',
    limit: String(PAGE_SIZE),
  });
  if (search) params.set('search', search);

  const res = await fetch(`/api/asociacion?${params.toString()}`);
  if (!res.ok) throw new Error('Error cargando asociación clientes');
  return res.json();
}

export async function fetchRecetasAsociacion(params = {}) {
  const p = new URLSearchParams();
  p.set('page', String(params.page ?? 1));
  p.set('limit', String(params.limit ?? PAGE_SIZE));
  if (params.search) p.set('search', params.search);

  const res = await fetch(`/api/asociacion-recetas?${p.toString()}`);
  if (!res.ok) throw new Error('Error cargando asociación de recetas');
  return res.json();
}

